import React from 'react';

import { Main, ServiceCard } from '@/components';
import { Dash, DashColumn } from '@/icons';

import styles from './service.module.scss';

const Service: React.FC = () => {
  const cards = [
    { id: 1, text: 'Оставьте заявку' },
    {
      id: 2,
      text: 'Менеджер свяжется с вами в течение 12 часов и расскажет, как пользоваться продуктом'
    },
    {
      id: 3,
      text: 'Заключение договора, обмен документами, приглашение в ЭДО и подписание договора'
    },
    {
      id: 4,
      text: 'Выдача доступов, заведение водителей и автомобилей в системе'
    },
    { id: 5, text: 'Старт обслуживания', isLast: true }
  ];

  return (
    <div className={styles.container}>
      <Main>
        <h2 className={styles.container__title}>
          Начните обслуживать <br /> автопарк в{' '}
          <span className={styles.container__title_info}>FIT FLEET</span>
        </h2>
        <div className={styles.container__items}>
          {cards.map((card) => (
            <ServiceCard
              key={card.id}
              className={styles.container__card}
              id={card.id}
              text={card.text}
              isLast={card.isLast}
            />
          ))}
          <Dash className={styles.container__items_dash} />
          <DashColumn className={styles.container__items_dashColumn} />
        </div>
      </Main>
    </div>
  );
};

export default Service;
